import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import type {PublishingScreencloudPanelProps} from './publishing-screencloud-panel.types';
import {Text, TextSize} from '@Components/text';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import {useCopyButton} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.hooks';
import type {DisplayCodeForSignage} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';
import {fetchDisplayCodeAsync, getProductUsed} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';
import {DigitalSignageOption} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.types';

export function PublishingScreencloudPanel({...props}: PublishingScreencloudPanelProps): ReactElement<any> {
  const [displayCode, setDisplayCode] = useState('');
  const [generatedIframe, setGeneratedIframe] = useState('');
  const [clicked, setClicked] = useState(false);
  const productUsed = getProductUsed();

  useEffect(() => {
    setTimeout(() => {
      setClicked(false);
    }, 3000);
  }, [clicked]);

  useEffect(() => {
    void fetchDisplayCodeAsync(productUsed).then((response: DisplayCodeForSignage | null) => {
      if (response !== null) {
        setDisplayCode(response.displayCode);
        setGeneratedIframe(response.generatedIframe);
      }
    });
  }, [displayCode]);

  const listItemElement: ReactElement<any> = (
    <div className="content-sub-text">
      <Text val={window.i18next.t('pmwjs_screencloud_follow_steps')} size={TextSize.XSMALL} />
      <div className="flexbox flex-v-row">
        <Text dangerouslySetInnerHTML className="spacing-p-b-2" val={window.i18next.t('pmwjs_screencloud_step1')} size={TextSize.XSMALL} />
        <Text className="spacing-p-b-2" val={window.i18next.t('pmwjs_screencloud_step2')} size={TextSize.XSMALL} />
        <Text val={window.i18next.t('pmwjs_screencloud_step3')} size={TextSize.XSMALL} />
      </div>
    </div>
  );

  const onCopyLink = (): void => {
    void window.PMW.writeLocal('cart/addOrderUsedByDigitalSignage', {
      orderId: productUsed?.orderId,
      type: DigitalSignageOption.SCREENCLOUD,
    });
  };

  return (
    <DigitalSignageSubPanel
      panelHeading={window.i18next.t('pmwjs_screencloud')}
      heading={window.i18next.t('pmwjs_screencloud_digital_signage')}
      showButton
      showInputBar
      inputBarIcon="icon-code"
      onClose={props.onClose}
      listItem={listItemElement}
      webpageLink={generatedIframe}
      onClick={() => {
        void window.PMW.copyToClipboard(generatedIframe);
        onCopyLink();
      }}
      buttonComponent={useCopyButton(clicked, generatedIframe, setClicked, onCopyLink)}
      imgSrc="publishing-screencloud.png"
    />
  );
}
